import React from 'react';
const languages: Record<string, [string, string]> = {
 es: ['Español', '/flags/es.svg'], ca: ['Mallorquí', '/mallorca.svg'], en: ['English', '/flags/gb.svg'],
 de: ['Deutsch', '/flags/de.svg'], fr: ['Français', '/flags/fr.svg'], it: ['Italiano', '/flags/it.svg'], pt: ['Português', '/flags/pt.svg'],
};
export default function CustomerLanguage({language}: {language?: string | null}) {
 const entry = language && languages[language];
 if (!entry) return null;
 return <span title={`Idioma del cliente: ${language === 'ca' ? 'Mallorquí / Català' : entry[0]} (Wakyma)`} style={{display:'inline-flex',alignItems:'center',gap:5,borderRadius:10,padding:'0 9px 0 0',background:'#ecebf1',color:'#292932',fontSize:12,height:19,lineHeight:'19px',whiteSpace:'nowrap',verticalAlign:'middle'}}>
  <img src={entry[1]} alt={language === 'ca' ? 'Bandera de Mallorca' : ''} width="19" height="19" style={{display:'block',flexShrink:0,borderRadius:'50%',objectFit:'cover'}}/>
  {entry[0]}
 </span>;
}
